import { select } from '@angular-redux/store';
import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { Observable } from 'rxjs/Observable';
import { PbScreenService } from '../../../../pb-screen/services/pb-screen.service';
import { PlanningBlock } from '../../../../pb-screen/models/planning-block/planning-block.interface';
import {DepotInActions} from '../../../../depot-in/depot-in.actions';
import {DepotOutActions} from '../../../../depot-out/depot-out.actions';
import {PbActions} from '../../../../pb-screen/pb.actions';

@Component({
  moduleId   : module.id,
  selector   : 'shared-move-planning-blocks',
  templateUrl: './move-planning-blocks-modal.component.html'
})

export class MovePlanningBlocksModalComponent implements OnInit {
  @select('loading') public loading$: Observable<boolean>;

  loadingSpinner: boolean = false;

  @ViewChild('modal') public modal: ElementRef;

  @Input() planningBlocksToDisplay: PlanningBlock[];
  @Input() screen: '' | 'DEPOT-IN' | 'DEPOT-OUT';

  @Output() moved = new EventEmitter<undefined>();

  moveDate: Date = new Date();

  constructor(
    private pbActions: PbActions,
    private depotInActions: DepotInActions,
    private depotOutActions: DepotOutActions,
    private pbService: PbScreenService,
    private toastr: ToastrService
  ) {
  }

  ngOnInit(): void {

  }

  closeModal() {
    this.modal.nativeElement.click();
    this.moveDate = new Date();
    this.pbActions.resetActionBarStates();

    if (this.screen) {
      if (this.screen === 'DEPOT-IN') {
        this.depotInActions.setDepotInSelection([]);
      } else if (this.screen === 'DEPOT-OUT') {
        this.depotOutActions.setDepotOutSelection([]);
      }
    }
  }

  applyUpdate() {
    if (this.screen) {
      let action;

      if (this.screen === 'DEPOT-IN') {
        action = (data) => this.depotInActions.updatePlanningBlocks(data);
      } else if (this.screen === 'DEPOT-OUT') {
        action = (data) => this.depotOutActions.updatePlanningBlocks(data);
      }

      this.pbActions.setSelectedPlanningBlocks([]) ;

      this.handleUpdate(action);
    }
  }

  private handleUpdate(actionToPerform: Function) {
    this.loadingSpinner = true;
    const pbIDs = this.planningBlocksToDisplay.map(pb => pb.id).join(',');

    this.pbService.updatePlanningBlockDates(pbIDs, this.moveDate.toISOString()).subscribe(data => {
      actionToPerform(data);
      this.toastr.success('Planning Block(s) updated Successfully');
      this.pbActions.updatePlanningBlocksDisplay(data) ;
      this.moved.emit();
      this.loadingSpinner = false;
      this.closeModal();
    }, (err) => {
      this.loadingSpinner = false;
    });
  }
}
